export default {
  testCases: [],
  consentUrls: {},
  hasRunStarted: false,
  test_cases_completed: false,
  ws: {
    connection: null,
    messages: [],
  },
  tokens: {
    acquired: [],
    all_acquired: false,
  },
};
